(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('studio-contact-{{ section.id }}');
    if (!root || root.dataset.studioContactInit === '1') return;
    root.dataset.studioContactInit = '1';

    // Consent → submit gating
    var consent = root.querySelector('[data-consent]');
    var submit = root.querySelector('[data-contact-submit]');
    if (consent && submit) {
      var toggle = function () { submit.disabled = !consent.checked; };
      consent.addEventListener('change', toggle);
      toggle();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
